<finxone-web-frontend-international-beneficiary-credentials
  [recipientName]="recipientName"
  [firstName]="firstName"
  [lastName]="lastName"
  [addressRequired]="addressRequired"
  [beneficiaryType]="beneficiaryType"
  [previousButtonContent]="previousButtonContent"
  [previousButtonStyle]="previousButtonStyle"
  [nextButtonContent]="nextButtonContent"
  [nextButtonStyle]="nextButtonStyle"
  [contentStyle]="contentStyle"
  [widgetProperties]="widgetProperties"
  [isSubmitTypeAsynchronous]="isSubmitTypeAsynchronous"
  (valuesChangedEvent)="updateFormActionStateOnChange($event)"
  [buttonGlobalStyles]="buttonGlobalStyles"
></finxone-web-frontend-international-beneficiary-credentials>
